import { Box, Icon } from '@medely/ui-kit';
import React from 'react';

type InfoCircleButtonProps = {
  testid?: string;
  onClick: () => void;
};

export const InfoCircleButton = ({ onClick, testid }: InfoCircleButtonProps) => {
  const testIdText = testid && 'info-circle-button';
  return (
    <Box onClick={() => onClick()} testId={testIdText}>
      <Icon name="light-info-circle" variant="custom" color="state.teal.primary" />
    </Box>
  );
};
